import React from 'react';
import { cn } from '@/lib/utils';

/**
 * Responsive grid for MetricCard / stat widgets. `cols` sets the max
 * columns at the largest breakpoint; scales down automatically.
 */
const StatGrid = ({ children, cols = 4, className }) => {
  const colsClass = {
    2: 'sm:grid-cols-2',
    3: 'sm:grid-cols-2 lg:grid-cols-3',
    4: 'sm:grid-cols-2 lg:grid-cols-4',
    5: 'sm:grid-cols-2 lg:grid-cols-3 xl:grid-cols-5',
    6: 'sm:grid-cols-2 lg:grid-cols-3 xl:grid-cols-6',
  }[cols] || 'sm:grid-cols-2 lg:grid-cols-4';

  return <div className={cn('grid grid-cols-1 gap-4', colsClass, className)}>{children}</div>;
};

export default StatGrid;
